import { render, staticRenderFns } from "./Resolved.vue?vue&type=template&id=08244068&scoped=true&"
import script from "./Resolved.vue?vue&type=script&lang=js&"
export * from "./Resolved.vue?vue&type=script&lang=js&"
import style0 from "./Resolved.vue?vue&type=style&index=0&id=08244068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08244068",
  null
  
)

export default component.exports